
// Valid Mapbox public token
export const MAPBOX_TOKEN = "pk.eyJ1IjoiaG91c2U4OGNyZWF0aXZlIiwiYSI6ImNtOW0yOGJ6aDA0NW4ya3NlZ2VoYW95djIifQ.d9vy2OMNh1D3fr_Lm51-JQ";

// Joshua Project API key
export const JOSHUA_PROJECT_API_KEY = "ac553cd16d18";
export const getJoshuaProjectApiUrl = (endpoint: string) => {
  return `https://api.joshuaproject.net/${endpoint}?api_key=${JOSHUA_PROJECT_API_KEY}`;
};
